"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesImportSelectHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/sites/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
const alert_1 = require("../../../../components/ui/alert");
require("./sites-import-select-header.less");
const core_1 = require("@material-ui/core");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const paper_1 = require("client/components/material/paper");
let SitesImportSelectHeader = class SitesImportSelectHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.parsedRows = [];
        this.parsedRowsTruncated = [];
        this.rowSelected = false;
        this.noHeaderRowSelectOnConfirm = false;
        this.getImportedRowsObject = () => {
            const headers = this.parsedRowsTruncated.slice(0, 1)[0]
                ? this.parsedRowsTruncated
                    .slice(0, 1)[0]
                    .map((header) => header.trim())
                : this.parsedRowsTruncated.slice(0, 1)[0];
            const rows = this.parsedRowsTruncated.slice(1);
            const importedData = rows.map(row => {
                const patient = {};
                row.forEach((value, index) => {
                    patient[headers[index]] = value;
                });
                return patient;
            });
            return importedData;
        };
        this.handleOnConfirmation = () => {
            if (!this.rowSelected) {
                // logic to pop modal to tell user to select a header row.
                this.noHeaderRowSelectOnConfirm = true;
            }
            else {
                store_1.sitesStore.importColumnsHeader = this.parsedRows[Number(this.selectedRowIndex) || 0];
            }
            this.parsedRowsTruncated = this.parsedRows.slice(Number(this.selectedRowIndex));
            store_1.sitesStore.importedSites = this.getImportedRowsObject();
            store_1.sitesStore.selectedRowIndex = this.selectedRowIndex;
        };
        this.handleOnCancel = () => {
            console.log("handleOnCancel triggered");
        };
        this.handleOnClickRow = (e, i) => {
            const rowClicked = document.getElementById(`select-header-table__row--${i}`);
            const allRows = document.getElementsByClassName("select-header-table__row");
            [...allRows].forEach(row => row.classList.remove("active-row"));
            rowClicked.classList.add("active-row");
            this.selectedRowIndex = i;
            this.rowSelected = true;
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, id: `select-header-table__row--${i}`, onClick: e => this.handleOnClickRow(e, i), key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
    }
    // componentWillReceiveProps() {
    //   console.log('cwrp triggered');
    // }
    componentWillMount() {
        this.parsedRows =
            store_1.sitesStore.parsedRows && store_1.sitesStore.parsedRows.length
                ? store_1.sitesStore.parsedRows[0]
                : [];
    }
    componentDidMount() {
        this.parsedRows = store_1.sitesStore.parsedRows[0]
            ? store_1.sitesStore.parsedRows[0].length
                ? store_1.sitesStore.parsedRows[0]
                : []
            : [];
        // sitesStore.importedSites = this.getImportedRowsObject();
    }
    render() {
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--select" },
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Header Selection", subLabel: "" })),
                React.createElement(paper_1.MaterialPaper, null,
                    this.noHeaderRowSelectOnConfirm && (React.createElement("div", { className: "ui-alert--error" },
                        React.createElement(alert_1.UiAlert, { message: "Missing header row selection.", dismissable: true, onRequestDismiss: () => (this.noHeaderRowSelectOnConfirm = false) }))),
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please select a header row"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/pharmacies" }, "Cancel"),
                            React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnConfirmation, to: this.rowSelected ? "/pharmacies/import/map" : null, disabled: !this.rowSelected }, "confirm"))),
                    React.createElement("div", { className: "select-header-table", style: { overflow: "auto" } },
                        React.createElement(core_1.Table, null,
                            React.createElement(core_1.TableBody, null, this.parsedRows // change to this.localTable for testing; this.parsedRows when done
                                .slice(0, 20)
                                .map((row, i) => this.renderTableRow(row, i))))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" }))));
    }
};
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "parsedRowsTruncated", void 0);
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "rowSelected", void 0);
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], SitesImportSelectHeader.prototype, "noHeaderRowSelectOnConfirm", void 0);
SitesImportSelectHeader = __decorate([
    mobx_react_1.observer
], SitesImportSelectHeader);
exports.SitesImportSelectHeader = SitesImportSelectHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-import-select-header/sites-import-select-header.tsx
// module id = 4087
// module chunks = 0